import React, { Component } from 'react';
import L from 'leaflet';
import omnivore from 'leaflet-omnivore';
import PropTypes from 'prop-types';

import { generarCapaBase } from './mapa';
import topojsonCatalunya from '../../commons/topojsonCatalunyaEnWGS84.json';
import { numeroDeDecimalsCoordenades } from '../../constants';
import { crearNotificacioWarning } from '../../commons/notificacio';

const coordenadesCentreCatalunya = { latitud: 41.5867, longitud: 1.6122 };
const nivellZoomMapaPerDefecte = 7;

const notificacioCoordenadesDinsCatalunyaAdvertencia = 'Només es poden seleccionar coordenades de Catalunya';

class LocalitzacioIntroduccioMapa extends Component {
	constructor(props) {
		super(props);

		this.obrePopupACoordenades = this.obrePopupACoordenades.bind(this);
	}

	generarCapaTopojson() {
		const estilsCapa = L.geoJson(null, {
			style: () => {
				return { opacity: 0.2, fillOpacity: 0.2, weight: 2, color: '#0652DD' };
			}
		});

		return omnivore.topojson.parse(topojsonCatalunya, null, estilsCapa);
	}

	obrePopupACoordenades(coordenades) {
		const zoomACoordenades = (coordenades) => {
			this.mapa.flyTo(coordenades, 10);
		};

		const { lat, lng } = coordenades;
		const coordenadesFormatPerMostrar = `${lat}°, ${lng}°`;

		this.popup
			.setLatLng(coordenades)
			.setContent(coordenadesFormatPerMostrar)
			.openOn(this.mapa);

		zoomACoordenades(coordenades);
	}

	esCoordenadaValida(properesCoordenades, capaTopojson) {
		if (!capaTopojson) {
			return true;
		}

		return this.estaLaCoordenadaDinsDeCatalunya(properesCoordenades, capaTopojson);
	}

	estaLaCoordenadaDinsDeCatalunya(properesCoordenades, capaTopojson) {
		const coordenadesArray = [properesCoordenades.longitud, properesCoordenades.latitud];
		const coordenadesPoligonsTopojson = capaTopojson._layers[Object.keys(this.capaTopojson._layers)[0]].feature.geometry.coordinates;

		const estaElPuntDinsLaRegio = (point, vs) => {
			// ray-casting algorithm based on
			// http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

			var x = point[0],
				y = point[1];

			var inside = false;
			for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
				var xi = vs[i][0],
					yi = vs[i][1];
				var xj = vs[j][0],
					yj = vs[j][1];

				var intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
				if (intersect) inside = !inside;
			}

			return inside;
		};

		return coordenadesPoligonsTopojson.some((coordenada) => {
			return estaElPuntDinsLaRegio(coordenadesArray, coordenada[0]);
		});
	}

	componentDidMount() {
		const habilitarCoordenadesForaCatalunya = this.props.habilitarCoordenadesForaCatalunya;
		const coordenades = this.props.coordenades;
		const coordenadesSeleccionades = coordenades && coordenades.latitud && coordenades.longitud ? coordenades : null;
		const coordenadesCentreMunicipi = coordenadesSeleccionades || coordenadesCentreCatalunya; //per defecte, centre Catalunya
		const coordenadesInicials = L.latLng(coordenadesCentreMunicipi.latitud, coordenadesCentreMunicipi.longitud);

		var layer = generarCapaBase();
		const configuracioMapa = {
			maxZoom: 13,
			minZoom: 7,
			zoom: nivellZoomMapaPerDefecte,
			maxBounds: [[43, -0.06], [40.37, 3.57]],
			center: coordenadesInicials,
			layers: [layer],
			attributionControl: false
		};

		const mapa = L.map(this.mapaLocalitzacio, configuracioMapa);

		this.capaTopojson = null;

		if (!habilitarCoordenadesForaCatalunya) {
			this.capaTopojson = this.generarCapaTopojson().addTo(mapa);
		}

		const onMapClick = (event) => {
			const coordenadesSeleccionades = event.latlng;
			const latitud = coordenadesSeleccionades.lat;
			const longitud = coordenadesSeleccionades.lng;

			if (this.esCoordenadaValida({ latitud, longitud }, this.capaTopojson)) {
				const latitudTruncada = parseFloat(latitud.toFixed(numeroDeDecimalsCoordenades));
				const longitudTruncada = parseFloat(longitud.toFixed(numeroDeDecimalsCoordenades));

				this.props.onChangeCoordenades({ latitud: latitudTruncada, longitud: longitudTruncada });
			} else {
				this.props.onChangeCoordenades({ latitud: null, longitud: null });
				crearNotificacioWarning(notificacioCoordenadesDinsCatalunyaAdvertencia);
			}
		};

		mapa.on('click', onMapClick);

		this.mapa = mapa;
		this.popup = L.popup();

		if (coordenadesSeleccionades) {
			this.obrePopupACoordenades(coordenadesInicials);
		}
	}

	componentWillReceiveProps(nextProps) {
		const properesCoordenades = nextProps.coordenades;
		const shanSeleccionatNovesCoordenades = (properesCoordenades) => {
			const hiHaCoordenades = (coordenades) => {
				return coordenades != null && coordenades.hasOwnProperty('latitud') && coordenades.hasOwnProperty('longitud') && coordenades.latitud != null && coordenades.longitud != null;
			};
			const shanModificatCoordenades = (coordenades) => {
				return coordenades !== this.props.coordenades;
			};
			return hiHaCoordenades(properesCoordenades) && shanModificatCoordenades(properesCoordenades);
		};

		if (shanSeleccionatNovesCoordenades(properesCoordenades)) {
			if (this.esCoordenadaValida(properesCoordenades, this.capaTopojson)) {
				const coordenadesSeleccionades = L.latLng(properesCoordenades.latitud, properesCoordenades.longitud);
				this.obrePopupACoordenades(coordenadesSeleccionades);
			} else {
				this.props.onChangeCoordenades({ latitud: null, longitud: null });
				crearNotificacioWarning(notificacioCoordenadesDinsCatalunyaAdvertencia);
			}
		}

		const noEsPodenMostrarCoordenadesSeleccionades = (properesCoordenades) => {
			const coordenades = this.props.coordenades;

			return (
				(properesCoordenades != null && (properesCoordenades.latitud == null || properesCoordenades.longitud == null) && coordenades && coordenades.latitud != null && coordenades.longitud != null) ||
				(properesCoordenades == null && coordenades != null && coordenades.latitud != null && coordenades.longitud != null)
			);
		};

		if (noEsPodenMostrarCoordenadesSeleccionades(properesCoordenades)) {
			const tancaPopupIInicialitzaMapa = () => {
				this.popup.remove();
				const coordenadesPerDefecte = L.latLng(coordenadesCentreCatalunya.latitud, coordenadesCentreCatalunya.longitud);
				this.mapa.flyTo(coordenadesPerDefecte, nivellZoomMapaPerDefecte);
			};

			tancaPopupIInicialitzaMapa();
		}
	}

	componentWillUnmount() {
		this.mapa.stop();
		this.mapa.remove();
	}

	render() {
		const { classeCss, habilitarCoordenadesForaCatalunya } = this.props;
		return <div className={classeCss} style={habilitarCoordenadesForaCatalunya ? { cursor: 'pointer' } : null} ref={(ref) => (this.mapaLocalitzacio = ref)}></div>;
	}
}

LocalitzacioIntroduccioMapa.propTypes = {
	coordenades: PropTypes.object,
	classeCss: PropTypes.string,
	habilitarCoordenadesForaCatalunya: PropTypes.bool,
	onChangeCoordenades: PropTypes.func
};

export default LocalitzacioIntroduccioMapa;



// WEBPACK FOOTER //
// ./src/components/commons/localitzacioIntroduccioMapa.js